import { useGetMentorsByUniversity } from '@actions';
import Modal from '@components/V4/Modal/Modal';
import { PaginationProps } from '@components/V4/Pagination';
import DetailsModal, {
  DetailsModalPage,
} from '@modules/Admin/components/DetailsModal/DetailsModal';
import { UserRole } from '@shared/enums';
import { useState } from 'react';
import ProfilesModalTable from '../ProfilesModalTable';

interface MentorsByUniversityProps {
  university: string;
  title: string;
}

const MentorsByUniversity = (props: MentorsByUniversityProps) => {
  const { university, title } = props;
  const [limit, setLimit] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const { data: mentorsByUniversity, isLoading: areUsersLoading } = useGetMentorsByUniversity({
    limit,
    page,
    sortBy,
    sortOrder,
    university,
  });

  const currentPageChangeHandler = (page: number) => {
    setPage(page);
  };

  const pageSizeChangeHandler = (size: number) => {
    setLimit(size);
  };

  const pagination: PaginationProps = {
    pageSize: limit || 10,
    total: mentorsByUniversity ? mentorsByUniversity.total : 0,
    currentPage: page || 1,
    onCurrentPageChange: currentPageChangeHandler,
    onPageSizeChange: pageSizeChangeHandler,
  };

  const usersList = mentorsByUniversity?.users;

  const [userId, setUserId] = useState<string>();
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const userModalOpenHandler = (userId: string) => {
    setUserId(userId);
    setShowDetailsModal(true);
  };
  const closeSessionModalHandler = () => {
    setShowDetailsModal(false);
  };

  return (
    <>
      <Modal.Header title={`Mentors from ${title}:`} />
      <Modal.Body>
        <ProfilesModalTable
          usersList={usersList || []}
          areUsersLoading={areUsersLoading}
          pagination={pagination}
          userModalOpenHandler={userModalOpenHandler}
          role={UserRole.Mentor}
        />
      </Modal.Body>
      {showDetailsModal && (
        <DetailsModal
          page={'mentor'}
          isOpen={true}
          onClose={closeSessionModalHandler}
          mentorId={userId}
        />
      )}
    </>
  );
};

export default MentorsByUniversity;
